<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)" srcset="assets/img/school-desktop-banners/ArniSchoolofEducationSports.webp">
        <source media="(min-width:768px)"
                srcset="assets/img/school-desktop-banners/medium-screen/ArniSchoolofEducationSports.webp">
        <img
            src="assets/img/mobile-banners-schools/ArniSchoolofEducationSports.webp"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>

<section class="aarni-font py-12">
    <div class="container mx-auto p-4">
        <div
            class="md:flex flex-wrap hidden space-x-4 p-6 xl:p-4 mb-4 border-2 border-gray-200 rounded-full gap-y-3 mx-auto xl:justify-center">
            <a href="#overview"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400  active-tab">Overview</a>
            <a href="#courses"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Courses</a>
            <a href="#specialisation"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Specialization</a>
            <a href="#hod-message"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">HOD's
                Message</a>
            <a href="#whats-happening"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">What's
                Happening</a>
            <a href="#expert-faculty"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Expert
                Faculty</a>
            <!--<a href="#testimonials"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Testimonials</a>-->
            <a href="#gallery"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Gallery</a>
            <a href="#recruiters"
               class="tab-link text-gray-500 font-medium hover:text-blue-400 lg:border-b xl:border-0 hover:border-blue-400 ">Recruiters</a>
        </div>
        <div id="overview" class="section p-4">
            <h2 class="text-3xl font-bold mb-2">Arni School of Education & Sports</h2>
            <h2 class="text-xl font-bold mb-2">Overview</h2>
            <p class="text-gray-500 text-justify">The ARNI School of Education and Sports is a combination of teaching
                physical education with science. The school promotes physical fitness, mental health, and team spirit in
                education, not only academic success. ARNI University is fully focused on preparing future educators and
                sports professionals who will motivate and respect the nation, inspire, and lead with integrity and
                passion.
            </p>
            <p class="text-gray-500 text-justify">We offer comprehensive courses that combine theoretical knowledge with
                hands-on field training, workshops, internships, and real-life teaching or coaching exposure. Whether
                you're aiming to become a school teacher, educational administrator, or professional sports trainer, our
                curriculum ensures holistic development.</p>
            <p class="text-gray-500 text-justify">ARNI University offers modern infrastructure, cutting-edge sports
                laboratories, player conditioning centers, and a motivated faculty. ARNI University is developing a new
                generation of education and sport professionals who are mentally fit, emotionally intelligent, and fit
                for life. We don't just teach you to educate or to coach; we teach you to lead and inspire.</p>
            <p class="text-gray-500 text-justify my-2"><strong>Vision -</strong> Our vision is to create well-educated
                and decent sports professionals who honor not only us but the entire nation with their exceptional
                gaming spirit that blends with ethics and sports spirit. We would like to be counted among the globally
                recognized centers of excellence in education and sports.
            </p>
            <p class="text-gray-500 text-justify my-2"><strong>Mission -</strong> Our mission is to deliver innovative
                and inclusive educational programs that foster intellectual growth, creativity, and critical thinking.
                We are on a mission to develop world-class sports professionals equipped with relevant skills and
                knowledge.
            </p>
        </div>

        <div id="courses" class="section p-4">
            <h2 class="text-xl font-bold mb-2">Courses</h2>
            <p class="text-gray-500 text-justify">Bachelor of Physical Education and Sports colleges emphasize
                comprehensive training for students to achieve academic success and develop athletic qualities. The
                school's faculty, including subject matter experts, provides innovative teaching methods and
                personalized instruction, preparing students for both academic and professional careers. The school also
                provides sports areas, skilled coaching staff, and state-of-the-art facilities.
            </p>
            <p class="text-gray-500 text-justify">The school believes in the power of education to transform lives and
                cultivate well-rounded individuals ready to contribute positively to society. Our courses focus on
                teaching methodologies, child psychology, sports science, pedagogy, training techniques, curriculum
                design, and educational technology. Students gain insights into both theoretical principles and
                practical strategies to make an impact in classrooms, playgrounds, and training fields.
            </p>
            <p class="text-gray-500 text-justify"><strong>Scope: </strong>The ARNI School of Education & Sports offers
                immense opportunities for aspiring educators and sports professionals to carve successful careers while
                contributing to societal progress with a Bachelor of Physical Education and Sports.
            </p>
            <ul class="list-disc px-5">
                <li class="text-gray-500 text-justify my-2">With NEP 2020 reforming India’s education system, there is
                    an increased demand for professionally trained and digitally literate teachers and education
                    specialists across schools, colleges, and learning centers.
                </li>
                <li class="text-gray-500 text-justify my-2">Graduates can explore teaching and training jobs not only in
                    India but also in international schools and sports academies abroad, especially in Gulf countries
                    and Southeast Asia.
                </li>
                <li class="text-gray-500 text-justify my-2"> Students can venture into research in areas like
                    educational psychology, curriculum innovation, or sports science, contributing to academic and
                    athletic advancements.
                </li>
                <li class="text-gray-500 text-justify my-2"> With the boom in online education and digital learning
                    platforms, there are emerging roles in content creation, curriculum design, and e-learning
                    coordination.
                </li>
                <li class="text-gray-500 text-justify my-2"> Graduates can open coaching centers, fitness clubs, yoga
                    institutes, or even start educational consultancies, becoming job creators rather than job seekers.
                </li>
                <li class="text-gray-500 text-justify my-2">Postgraduates can pursue leadership roles in schools, sports
                    academies, and educational institutions as principals, coordinators, or program heads.
                </li>
            </ul>
            <p class="my-2 text-gray-500 font-semibold">The skills gained at the ARNI School of Education & Sports are
                transferable, empowering students to excel in diverse fields, including education, sports science, and
                leadership roles in corporate and community settings. Join us now and explore the world of fitness and
                sports for better career opportunities.
            </p>
            <h4 class="text-xl font-bold mb-2">Career Opportunities</h4>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2"><span class="font-semibold">School Teacher / Physical Education Instructor -</span>
                    Shape young minds through interactive teaching or by instilling discipline and fitness in students
                    as a trained PE teacher.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Sports Coach / Trainer -</span> Become a
                    certified coach in specific sports disciplines and train athletes for schools, colleges, or
                    professional academies.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Curriculum Developer / Educational Coordinator -</span>
                    Design innovative teaching material and learning programs for schools, EdTech firms, or learning
                    consultancies.
                </li>
                <li class="text-gray-500 my-2"><span class="font-semibold">Fitness Consultant / Yoga Trainer -</span>Work
                    as a professional wellness expert, helping individuals maintain physical and mental health through
                    personalized training plans.
                </li>
                <li class="text-gray-500 my-2"><span
                    class="font-semibold"> Sports Event Manager / Administrator -</span>Plan and manage tournaments,
                    training camps, and school or college sports events in a leadership capacity.
                </li>
            </ul>

            <h2 class="text-xl font-bold mb-2">Arni University’s Contribution to Emerging Technologies</h2>
            <p class="text-gray-500 my-2">ARNI University plays an important role in developing well-rounded
                professionals, equally competitive in the field of education and sports. The School of Education and
                Sports offers state-of-the-art learning facilities, including smart classrooms, activity rooms, training
                gyms, sports fields, and educational resource centers. In addition, ARNI incorporates theory into
                practice by periodically teaching practicums.
            </p>
            <p class="text-gray-500 my-2">Our collaborations with reputed schools, sports organizations, and fitness
                brands ensure that the students will get industry exposure while pursuing their course at the
                university. The faculty consists of educators, physical trainers, child development specialists, and
                sports scientists who all provide critical learning perspectives from their experiences, thereby
                creating an engaging learning environment in the classroom, as well as in the field.
            </p>
            <p class="text-gray-500 my-2">We organize seminars, fund wellness drives, get involved in inter-university
                tournaments, and hold award ceremonies to ensure our students become job-ready and socially aware
                citizens in the industry. ARNI is ensuring that we are not just training professionals, but we are
                inspiring educational practitioners and sports leaders, with the capability to impact their
                communities.</p>

            <h2 class="text-xl font-bold mb-2">Why Choose ARNI?</h2>
            <ul class="list-disc px-5">
                <li class="text-gray-500 my-2"> ARNI connects academic learning and physical education to ensure
                    students can feel confident in the classroom, as well as in the fields.
                </li>
                <li class="text-gray-500 my-2">Students are mentored by qualified teachers, trainers, and athletes with
                    a background and practical knowledge of the industry.
                </li>
                <li class="text-gray-500 my-2"> ARNI's ecosystem is comprehensive, including everything from sports labs
                    and gyms, classrooms and smart tools for teaching.
                </li>
                <li class="text-gray-500 my-2">Students benefit from partnerships with the best schools, fitness clubs,
                    and academies to ensure that our students engage with the feeling of the industry for a real-world
                    experience and experience in teaching/ coaching.
                </li>
                <li class="text-gray-500 my-2">Our placement cell connects students with industry giants for internship
                    and placement opportunities
                </li>
                <li class="text-gray-500 my-2"> Students also get to engage in community service, youth training and
                    inter-college tournaments for fun, fitness and to engage in fitness drives to build confidence for
                    our students which develops their awareness in leadership skills and personal development.
                </li>
            </ul>

            <p class="my-2 text-gray-500 font-semibold">The skills gained at the ARNI School of Education & Sports are
                transferable, empowering students to excel in diverse fields, including education, sports science, and
                leadership roles in corporate and community settings. Join us now and explore the world of fitness and
                sports for better career opportunities. </p>
        </div>
    </div>
    <div id="specialisation" class="w-full bg-gray-100">
        <div class="max-w-7xl mx-auto p-6">
            <h2 class="text-2xl font-bold text-center mb-8 text-gray-800">Physical Education and Sports Disciplines &
                Specializations</h2>
            <div class="flex justify-center">
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 gap-6 w-full md:w-[40%]">
                    <div
                        *ngFor="let department of departments"
                        class="bg-white p-5 rounded-2xl shadow-md border border-gray-200 hover:shadow-lg transition-shadow duration-300"
                    >
                        <div class="flex items-center mb-4">
                            <i class="fa" [ngClass]="department.icon + ' text-2xl text-blue-600 mr-3'"></i>
                            <span class="text-xl font-semibold text-gray-800">{{ department.name }}</span>
                        </div>
                        <div class="max-h-40 overflow-y-auto custom-scrollbar pr-2">
                            <ul class="list-disc pl-6 text-sm text-gray-700 space-y-1">
                                <li *ngFor="let branch of department.branches">{{ branch }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bg-gradient-to-b from-indigo-500 to-blue-400 text-white py-8  text-center mt-6">
            <div class="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 py-8">
                <div>
                    <p class="text-3xl font-bold">200+</p>
                    <p class="text-lg">Programs</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">500+</p>
                    <p class="text-lg">Faculties</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">11000+</p>
                    <p class="text-lg">Students</p>
                </div>
                <div>
                    <p class="text-3xl font-bold">120+</p>
                    <p class="text-lg">Acre of campus</p>
                </div>
            </div>
        </div>
    </div>
    <div class="w-full">
        <div id="hod-message"
             class="max-w-6xl mx-auto bg-white shadow-lg rounded-lg flex flex-col md:flex-row overflow-hidden my-8 p-4">
            <div class="relative w-full md:w-1/3">
                <img
                    src="assets/img/school-wise-faculties/arni-school-of-sports/mr-narendra-pal-arni-school-of-education-and-sports.webp"
                    alt="Dean" class="w-full h-full object-cover">
                <div class="absolute bottom-0 left-0 right-0 bg-blue-500 text-white text-center py-2">
                    Dr. Narendra Pal
                </div>
            </div>
            <div class="w-full md:w-2/3 p-6 overflow-y-auto h-auto">
                <h2 class="text-2xl font-bold mb-2">HOD’s Message</h2>
                <p class="text-gray-700 text-justify">
                    Greetings and a warm welcome to all!
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    As the Head of Department (HOD) of ARNI University, I take immense pride in welcoming you to our
                    institution.
                    At ARNI University, we are committed to offering an education that fosters holistic development in
                    our students—academic excellence, mental well-being, and personal growth. We aim to provide
                    world-class education and training that not only equips our students with professional skills but
                    also nurtures their personal development.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    Our mission is to cultivate the best-skilled educators, leaders, coaches, and
                    changemakers—individuals who understand the transformative power of education and the discipline of
                    sports. To achieve this, we have brought together a team of experts and professionals who have
                    meticulously designed a comprehensive curriculum that integrates theory with practice, ensuring that
                    our students grow emotionally, physically, and intellectually.
                </p>
                <p class="text-gray-700 mt-4 text-justify">
                    Whether your goal is to become a thoughtful teacher, a sports psychologist, a physical trainer, or a
                    community educator, ARNI University provides the foundation to help you achieve your aspirations. I
                    invite you to join our vibrant, ever-growing community where education meets action, and dreams are
                    built with discipline.
                </p>
                <p class="text-gray-700 mt-2 text-justify">
                    Warm regards,
                </p>
                <p class="text-gray-700 mt-2 text-justify font-bold">
                    Dr. Narendra Pal
                </p>
                <p class="text-gray-700 mt-2 text-justify">
                    Head of Department, ARNI University
                </p>
            </div>
        </div>

        <div id="whats-happening" class="w-full">
            <div class="bg-gradient-to-b from-blue-500 to-blue-300 py-12">
                <div class="container mx-auto px-6">
                    <h2 class="text-white text-2xl font-bold text-center mb-6">WHAT’S HAPPENING IN SCHOOL</h2>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        <div *ngFor="let event of events" class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img [src]="event.image" alt="Event Image" class="w-full h-56 object-cover">
                            <div class="p-4">
                                <span
                                    class="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full absolute -mt-8">Event</span>
                                <!--<p class="text-sm text-gray-600 font-bold mt-3">{{ event.date }}</p>-->
                                <h3 class="text-lg font-semibold mt-2">{{ event.title }}</h3>
                                <p class="text-sm text-gray-600 mt-2">{{ event.description }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex justify-center mt-10">
                        <a
                            href="/whats-happening/event-calendar"
                            class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md"
                        >
                            View More
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div id="expert-faculty" class="w-full">
            <div class="relative w-full md:flex flex-col items-center bg-gray-100 py-8 hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="relative w-full max-w-6xl overflow-hidden">
                    <div
                        class="flex justify-center transition-transform duration-300 ease-in-out"
                        [ngStyle]="{ transform: 'translateX(' + translateX + '%)' }"
                    >
                        <div
                            *ngFor="let faculty of faculties"
                            class="flex-shrink-0 w-full sm:w-1/2 md:w-1/3 lg:w-1/4 p-4"
                        >
                            <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px]">
                                <div class="h-[140px] flex items-center justify-center">
                                    <img
                                        [src]="faculty.image"
                                        alt="faculty image"
                                        class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                    />
                                </div>
                                <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                    <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                    <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button
                    (click)="prev()"
                    class="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-left text-[#012E26]"></i>
                </button>
                <button
                    (click)="next()"
                    class="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white p-2 rounded-full shadow-md hover:bg-gray-200"
                >
                    <i class="fa fa-chevron-right text-[#012E26]"></i>
                </button>
                <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                        (click)="goTo('/about/faculty')">
                    View All Faculty
                </button>
            </div>
            <div class="relative w-full sm:flex flex-col items-center bg-gray-100 py-8 md:hidden">
                <h2 class="text-2xl font-bold mb-6 text-center">Expert Faculty</h2>
                <div class="w-full">
                    <div
                        *ngFor="let faculty of faculties | slice:0:3"
                        class="flex flex-col items-center p-4"
                    >
                        <div class="bg-white p-6 rounded-lg shadow-md flex flex-col items-center h-[350px] w-full">
                            <div class="h-[140px] flex items-center justify-center">
                                <img
                                    [src]="faculty.image"
                                    alt="faculty image"
                                    class="w-32 h-32 rounded-full border-4 border-white shadow-md"
                                />
                            </div>
                            <div class="h-[140px] flex flex-col items-center justify-center text-center">
                                <h3 class="mt-2 text-lg font-semibold">{{ faculty.name }}</h3>
                                <p class="text-sm text-gray-600 flex items-center mt-2">{{ faculty.designation }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="flex justify-center">
                    <button class="mt-6 px-4 py-2 bg-blue-500 text-white rounded-full shadow-md"
                            (click)="goTo('/about/faculty')">
                        View All Faculty
                    </button>
                </div>
            </div>
        </div>

       <!-- <div id="testimonials" class="py-16 bg-white font-montserrat">
            <div class="container mx-auto px-4 text-center">
                <h2 class="text-4xl font-bold text-[#012E26] mb-12">Testimonials</h2>
                <div class="testimonial-slider relative">
                    <div class="overflow-hidden px-2">
                        <div
                            class="flex transition-transform duration-500 ease-in-out"
                            [ngStyle]="{
            transform: 'translateX(' + -testimonialSlideIndex * 100 + '%)'
          }"
                        >
                            <ng-container *ngFor="let group of groupedTestimonials">
                                <div class="w-full flex-shrink-0 flex pb-4">
                                    <div
                                        *ngFor="let testimonial of group"
                                        class="w-full md:1/2 lg:w-1/3 px-3"
                                    >
                                        <div
                                            class="bg-white rounded-lg shadow-lg overflow-hidden transition-all duration-300 hover:shadow-xl h-full">
                                            <div class="bg-[#ff6347] h-32 rounded-t-lg relative">
                                                <div
                                                    class="absolute left-1/2 transform -translate-x-1/2 bottom-0 translate-y-1/2"
                                                >
                                                    <div class="w-24 h-24 rounded-full bg-white p-1">
                                                        <img
                                                            [src]="testimonial.image"
                                                            [alt]="testimonial.name"
                                                            class="w-full h-full rounded-full object-cover"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="pt-16 pb-8 px-6">
                                                <h3
                                                    class="text-xl font-semibold text-center text-[#012E26] mb-2"
                                                >
                                                    {{ testimonial.name }}
                                                </h3>
                                                <div class="flex justify-center mb-4">
                                                    <i
                                                        class="fa fa-star text-yellow-400"
                                                        *ngFor="let star of [1, 2, 3, 4, 5]"
                                                    ></i>
                                                </div>
                                                <p class="text-gray-700 text-center mb-6">
                                                    {{ testimonial.feedback }}
                                                </p>
                                                <div class="text-center text-sm text-gray-600">
                                                    <p class="font-semibold">{{ testimonial.course }}</p>
                                                    &lt;!&ndash;        <p class="font-bold text-[#012E26]">
                                                                Placed In:
                                                                <span class="text-[#00BFA5]">
                                  {{ testimonial.company }}
                                </span>
                                                            </p>&ndash;&gt;
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>

                    &lt;!&ndash; Pagination Dots &ndash;&gt;
                    <div class="flex justify-center mt-8 space-x-2">
                        <button
                            *ngFor="let group of groupedTestimonials; let i = index"
                            [ngClass]="{
            'bg-[#00BFA5]': testimonialSlideIndex === i,
            'bg-gray-300': testimonialSlideIndex !== i
          }"
                            class="w-3 h-3 rounded-full transition-all duration-300"
                            (click)="setTestimonialSlide(i)"
                        ></button>
                    </div>
                </div>

                <div class="flex justify-center mt-10">
                    <a
                        href="/quick-links/student-testimonial"
                        class="py-3 px-8 rounded-full bg-white text-[#012E26] hover:bg-[#00BFA5] hover:text-white transition-all duration-300 font-medium shadow-md border border-[#00BFA5]"
                    >
                        View More
                    </a>
                </div>
            </div>
        </div>-->

        <div id="gallery">
            <div class="container-fluid mb-10">
                <div class="flex flex-col md:flex-row">
                    <div class="w-full md:w-3/5 md:pr-4 mb-4 md:mb-0">
                        <img src="assets/img/academic-blocks/block-c.jpg" alt="Image 1"
                             class="w-full h-[500px] shadow-lg">
                    </div>
                    <div class="w-full md:w-2/5 md:pl-4">
                        <iframe class="w-full h-[500px] object-cover shadow-lg"
                                src="https://www.youtube.com/embed/RSa3v7KV2h4?si=qWzM2swYFmjZ0Sgm"
                                title="YouTube video player" frameborder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div id="recruiters" class="w-full">
            <div class="bg-blue-100 text-center font-sans py-12">
                <h2 class="text-xl md:text-2xl font-bold mb-4">Recruiters</h2>
                <div class="flex items-center justify-center gap-6 py-4">
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="prevSlide()">&#10094;
                    </button>
                    <div class="overflow-hidden w-[85%] sm:w-[90%] md:w-[80%] lg:w-[70%] flex items-center">
                        <div class="flex gap-3 sm:gap-4 transition-transform duration-500 ease-in-out self-center"
                             [style.transform]="'translateX(-' + (index * 120) + 'px)'">
                            <div *ngFor="let recruiter of recruiters"
                                 class="min-w-[100px] sm:min-w-[120px] p-2 sm:p-3 bg-white shadow-md rounded flex items-center justify-center">
                                <img [src]="recruiter.logo" [alt]="recruiter.name"
                                     class="max-w-[80px] sm:max-w-[100px] h-auto">
                            </div>
                        </div>
                    </div>
                    <button class="bg-white p-2 md:p-3 rounded-full shadow-md flex items-center justify-center"
                            (click)="nextSlide()">&#10095;
                    </button>
                </div>
                <!--                <button class="mt-4 bg-blue-500 text-white px-4 sm:px-6 py-2 rounded-full">View all</button>-->
            </div>
        </div>
    </div>
</section>
